<template>
	<section class="container page-content">
		<personal-details-modal
			:show-personal-details-modal="showPersonalDetailsModal"
			:details="personalDetails"
			@closePersonalDetailsModal="hidePersonalDetailsModal"
			@updatePersonalDetails="updatePersonalDetails"
		/>
		<contact-details-modal
			:show-contact-details-modal="showContactDetailsModal"
			:details="contactDetails"
			@closeContactDetailsModal="hideContactDetailsModal"
			@updateContactDetails="updateContactDetails"
		/>
		<security-details-modal
			:show-security-details-modal="showSecurityDetailsModal"
			:details="securityDetails"
			@closeSecurityDetailsModal="hideSecurityDetailsModal"
			@updateSecurityDetails="updateSecurityDetails"
		/>
		<div class="row">
			<div class="col-xs-12 col-sm-8">
				<h1>My profile</h1>
				<div class="page-summary-container">
					<div class="page-summary-text">
						View and update your personal information.
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12 col-sm-12 col-md-12 col-lg-9">
				<div class="table-responsive">
					<table class="table">
						<thead>
							<tr>
								<td colspan="2">
									<span class="h4">Personal details</span>
									<span>
										<b-btn
											class="btn btn-primary btn-xs"
											style="float:right;"
											@click="showPersonalDetailsModal=true"
										>Update</b-btn>
									</span>
								</td>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td style="width:25%">Name</td>
								<td id="names">{{ fullName }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12 col-sm-12 col-md-12 col-lg-9">
				<div class="table-responsive">
					<table class="table">
						<thead>
							<tr>
								<td colspan="2">
									<span class="h4">Contact details</span>
									<span>
										<b-btn
											class="btn btn-primary btn-xs"
											style="float:right;"
											@click="showContactDetailsModal=true"
										>Update</b-btn>
									</span>
								</td>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td style="width:25%">Email</td>
								<td id="emailAddressDisplay">{{ user.email_address }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12 col-sm-12 col-md-12 col-lg-9">
				<div class="table-responsive">
					<table class="table">
						<thead>
							<tr>
								<td colspan="2">
									<span class="h4">Security</span>
									<span>
										<b-btn
											class="btn btn-primary btn-xs"
											style="float:right;"
											@click="showSecurityDetailsModal=true"
										>Update</b-btn>
									</span>
								</td>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td style="width:25%">Password</td>
								<td>••••••••••</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import { mapGetters } from 'vuex';
import personalDetailsModal from '@/components/personal-details-modal';
import contactDetailsModal from '@/components/contact-details-modal';
import securityDetailsModal from '@/components/security-details-modal';
import { Notification } from 'uiv';


export default {
	components: { personalDetailsModal, contactDetailsModal, securityDetailsModal },
	created() {
		this.getUserDetails();
	},
	data() {
		return {
			user: {},
			showPersonalDetailsModal: false,
			showContactDetailsModal: false,
			showSecurityDetailsModal: false
		};
	},
	computed: {
		...mapGetters({ getUser: 'user' }),
		currentUser() {
			return this.getUser;
		},
		fullName() {
			return `${this.user.first_name} ${this.user.last_name}`;
		},
		personalDetails() {
			return {
				id: this.user.id,
				first_name: this.user.first_name,
				last_name: this.user.last_name
			};
		},
		contactDetails() {
			return {
				id: this.user.id,
				email_address: this.user.email_address
			};
		},
		securityDetails() {
			return { id: this.user.id };
		}
	},
	methods: {
		async getUserDetails() {
			const { data: { data: user } } = await this.$axios.get(`/user/${this.currentUser.id}`);
			this.$set(this, 'user', user);
		},
		hidePersonalDetailsModal() {
			this.showPersonalDetailsModal = false;
		},
		async updatePersonalDetails(options) {
			try {
				await this.$axios.patch(`/user/personal/${this.currentUser.id}`, options);
				Notification.notify({
					type: 'success',
					title: 'Personal details changed.',
					duration: 10000
				});
				this.hidePersonalDetailsModal();
				this.getUserDetails();
			} catch (e) {
				Notification.notify({
					type: 'danger',
					title: 'Could not edit personal details.',
					content: e.response ? e.response.data.message : '',
					duration: 10000
				});
			}
		},
		hideContactDetailsModal() {
			this.showContactDetailsModal = false;
		},
		async updateContactDetails(options) {
			try {
				await this.$axios.patch(`/user/contact/${this.currentUser.id}`, options);
				Notification.notify({
					type: 'success',
					title: 'Contact details changed.',
					duration: 10000
				});
				this.hideContactDetailsModal();
				this.getUserDetails();
			} catch (e) {
				Notification.notify({
					type: 'danger',
					title: 'Could not edit contact details.',
					content: e.response ? e.response.data.message : '',
					duration: 10000
				});
			}
		},
		hideSecurityDetailsModal() {
			this.showSecurityDetailsModal = false;
		},
		async updateSecurityDetails(options) {
			try {
				await this.$axios.patch(`/user/security/${this.currentUser.id}`, options);
				Notification.notify({
					type: 'success',
					title: 'Security details changed.',
					duration: 10000
				});
				this.hideSecurityDetailsModal();
				this.getUserDetails();
			} catch (e) {
				Notification.notify({
					type: 'danger',
					title: 'Could not edit security details.',
					content: e.response ? e.response.data.message : '',
					duration: 10000
				});
			}
		},
	}
};
</script>
